module.exports = __webpack_public_path__ + "static/media/logo_ingweb.4a3cfcc8.svg";